<ion-header>
  <ion-toolba>
    <header id="toolbar-header">
      <div class="header-left">
        <a href="https://m.penmateapp.com"><div class="pm-logo-text"></div></a>
      </div>
      <div class="header-right">
        <a href="/add-penmate" *ngIf="isMobile"> Send a message</a>
      </div>
    </header>
  </ion-toolba>
</ion-header>

<ion-content id="my-penmates">
  <div id="web-message">
    <div *ngIf="!penmate">
      <div class="app-logo-top">
        <div class="app-logo"></div>
      </div>
      <div class="sorry-message">
        <h2>Sorry, this page is not available.</h2>
        <p>The link you are using may be broken, or the page has been removed.</p>
        <div class="search-link-container">
          <a href="/search" class="search-instead-link">
            <ion-icon name="ios-search"></ion-icon>
            Try searching for this person instead
          </a>
        </div>
      </div>
    </div>
    <div *ngIf="penmate" class="penmate-info">
      <div class="penmate-avatar" *ngIf="penmate">
        <div class="icon-circle">
          <div class="inner-circle">
            <span *ngIf="penmate.initials && !penmate.image" class="initials"
              >{{penmate.initials}}</span
            >
            <img *ngIf="penmate.image" [src]="penmate.image" />
            <ion-icon *ngIf="!penmate.initials && !penmate.image" name="ios-person"></ion-icon>
          </div>
        </div>
      </div>
      <div class="connect-message">
        <h2>Connect with {{ penmate.first_name }} {{penmate.last_name}}</h2>
        <h5 class="facility">{{ penmate.facility }}</h5>

        <div>
          <a href="https://apps.apple.com/us/app/penmate-send-mail-to-jail/id955317881"
            ><div class="app-store-button"></div
          ></a>
          <a href="https://play.google.com/store/apps/details?id=com.penmate"
            ><div class="play-store-button"></div
          ></a>
        </div>
      </div>
    </div>
  </div>
</ion-content>
<ion-footer>
  <app-footer-nav></app-footer-nav>
</ion-footer>
